import { FREQUENCY_VALUES } from '@pro/web-common/core/messages/constants';


export const FREQUENCY_LABELS = {
  [FREQUENCY_VALUES.WEEKLY]: 'Every week',
  [FREQUENCY_VALUES.MONTHLY]: 'Every month',
};
